import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import messages from '../../messages';
import { map } from 'lodash/collection';
import moment from 'moment';
import numeral from 'numeral';
import { getGender, filteredParty, partyFilter } from 'helpers/lang';
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);
const StyledTableRow = withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.action.hover,
  },
}))(TableRow);
function createData(amount, startDate, endDate, frequency) {
  return { amount, startDate, endDate, frequency };
}
// const rows = [createData('Mr. Frank Smith', '02.05.1986', 'Male', 'Smoker')];
function Withdrawals(props) {
  const theme = useTheme();
  const { applicationDetails } = props;
  const isBolton = applicationDetails.isBolton;
  const productConfigs = isBolton
    ? applicationDetails.productConfigs[0]
    : applicationDetails.productConfigs;
  const currency = productConfigs?.currency;

  const amount = productConfigs?.regularWithdrawal?.amount;
  const startDate = productConfigs?.regularWithdrawal?.startDate;
  const endDate = productConfigs?.regularWithdrawal?.endDate;
  const frequency = productConfigs?.regularWithdrawal?.frequency;
  const educationFeesWithdrawalAmount =
    productConfigs?.educationFeesWithdrawal?.child1.amount;
  const educationFeesWithdrawalStartDate =
    productConfigs?.educationFeesWithdrawal?.child1.startDate;
  const educationFeesWithdrawalEndDate =
    productConfigs?.educationFeesWithdrawal?.child1.endDate;
  const educationFeesWithdrawalFrequency =
    productConfigs?.educationFeesWithdrawal?.child1.frequency;

  const row = [
    productConfigs?.regularWithdrawal?.selected
      ? numeral(productConfigs?.regularWithdrawal.percentage).value() != 0
        ? createData(
            `${productConfigs?.regularWithdrawal.percentage}%`,
            `${moment(startDate).format('DD MMM YYYY')}`,
            `${moment(endDate).format('DD MMM YYYY')}`,
            `${frequency}`,
          )
        : createData(
            `${currency} ${numeral(amount).format('0,0')}`,
            `${moment(startDate).format('DD MMM YYYY')}`,
            `${moment(endDate).format('DD MMM YYYY')}`,
            `${frequency}`,
          )
      : null,

    productConfigs?.educationFeesWithdrawal &&
    productConfigs?.educationFeesWithdrawal.selected
      ? createData(
          `${currency} ${numeral(educationFeesWithdrawalAmount).format('0,0')}`,
          `${moment(educationFeesWithdrawalStartDate).format('DD MMM YYYY')}`,
          `${moment(educationFeesWithdrawalEndDate).format('DD MMM YYYY')}`,
          `${educationFeesWithdrawalFrequency}`,
        )
      : null,

    !isEmpty(productConfigs?.educationFeesWithdrawal?.child2) &&
    productConfigs?.educationFeesWithdrawal.selected
      ? createData(
          `${currency} ${numeral(
            productConfigs?.educationFeesWithdrawal?.child2.amount,
          ).format('0,0')}`,
          `${moment(
            productConfigs?.educationFeesWithdrawal?.child2.startDate,
          ).format('DD MMM YYYY')}`,
          `${moment(
            productConfigs?.educationFeesWithdrawal?.child2.endDate,
          ).format('DD MMM YYYY')}`,
          `${productConfigs?.educationFeesWithdrawal?.child2.frequency}`,
        )
      : null,

    !isEmpty(productConfigs?.educationFeesWithdrawal?.child3) &&
    productConfigs?.educationFeesWithdrawal.selected
      ? createData(
          `${currency} ${numeral(
            productConfigs?.educationFeesWithdrawal?.child3.amount,
          ).format('0,0')}`,
          `${moment(
            productConfigs?.educationFeesWithdrawal?.child3.startDate,
          ).format('DD MMM YYYY')}`,
          `${moment(
            productConfigs?.educationFeesWithdrawal?.child3.endDate,
          ).format('DD MMM YYYY')}`,
          `${productConfigs?.educationFeesWithdrawal?.child3.frequency}`,
        )
      : null,

    !isEmpty(productConfigs?.educationFeesWithdrawal?.child4) &&
    productConfigs?.educationFeesWithdrawal.selected
      ? createData(
          `${currency} ${numeral(
            productConfigs?.educationFeesWithdrawal?.child4.amount,
          ).format('0,0')}`,
          `${moment(
            productConfigs?.educationFeesWithdrawal?.child4.startDate,
          ).format('DD MMM YYYY')}`,
          `${moment(
            productConfigs?.educationFeesWithdrawal?.child4.endDate,
          ).format('DD MMM YYYY')}`,
          `${productConfigs?.educationFeesWithdrawal?.child4.frequency}`,
        )
      : null,
  ];

  const getPaymentFrequency = (frequency,singlePremiumTerm) => {
    switch (frequency) {
      case 'Monthly':
        return 'p/month';

      case 'Quarterly':
        return 'p/quarter';

      case 'Half-Yearly':
        return 'p/half-year';

      case 'Yearly':
        return 'p/year';

      case 'Single':
        if (singlePremiumTerm > 0){
          return 'per year';
        } else {
          return 'Single time';
        }

      default:
        return '';
    }
  };

  const rows = row.filter(el => el !== null);
  if (rows.length > 0) {
    return (
      <Grid item xs={12} md={10}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              style={{ color: theme.palette.primary.subMain }}
            >
              <FormattedMessage {...messages.Withdrawals} />
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TableContainer>
              <Table aria-label="customized table">
                <TableBody>
                  {map(rows, (row, index) => {
                    if (row) {
                      return (
                        <StyledTableRow key={`${row.index}-${index}`}>
                          <StyledTableCell
                            component="th"
                            scope="row"
                            style={{ width: '25%' }}
                          >
                            <Typography variant="h4">{row.amount}</Typography>
                          </StyledTableCell>
                          <StyledTableCell style={{ width: '25%' }}>
                            <Typography variant="h4">
                              {row.startDate}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell style={{ width: '25%' }}>
                            <Typography variant="h4">{row.endDate}</Typography>
                          </StyledTableCell>
                          <StyledTableCell style={{ width: '25%' }}>
                            <Typography variant="h4">
                              {getPaymentFrequency(row.frequency,productConfigs?.singlePremiumTerm)}
                            </Typography>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    } else {
                      return null;
                    }
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return '';
  }
}
Withdrawals.propTypes = {
  parties: PropTypes.array,
};
export default Withdrawals;
